import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { McIcon } from 'makeclub-ui';

@Component({
  selector: 'mc-star-rating',
  template: `
    <div class="text-brand-primary flex items-center gap-1">
      @for (star of stars(); track $index) {
        <mc-icon [name]="star ? 'star-filled' : 'star'" class="text-brand-primary text-base" />
      }
      @if (showValue()) {
        <span class="text-text-primary ml-1 text-sm font-semibold">{{ rating() }}</span>
      }
    </div>
  `,
  imports: [McIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarRating {
  readonly rating = input<number | null | undefined>();

  protected readonly stars = computed(() => {
    const filled = Math.round(this.rating() ?? 0);
    return Array.from({ length: 5 }, (_, i) => i < filled);
  });

  protected readonly showValue = computed(() => {
    const r = this.rating();
    return r != null && r > 0;
  });
}
